// src/screens/DataDeletionScreen/components/DataDeletion/style.ts
import styled from 'styled-components';
import { colors } from 'constants/colors';
import { BasicSectionContainer } from 'screens/style';
import { sectionBackgroundStyles } from 'screens/sectionBackgroundStyles';
import { styleSizes } from 'constants/styleSizes';


export const DataDeletionContainer = styled(BasicSectionContainer)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  color: ${colors.almostBlack};

  .background {
    ${sectionBackgroundStyles}
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 20px;
    padding: 64px 0;
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        padding: 32px 0;
      }

    .title {
      width: 100%;
      font-size: 48px;
      text-align: center;
      font-weight: bold;
      color: ${colors.almostBlack};
      margin: 0 0 48px 0;
      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        font-size: 32px;
        font-weight: bold;
        text-align: left;
        margin: 0 0 32px 0;
      }
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        line-height: 48px;
        margin: 0 0 24px 0;
      }
    }

    .emailFl {
        margin: 16px 0 0 0;
    }

    .subtitle {
      width: 100%;
      font-size: 24px;
      text-align: left;
      font-weight: 600;
      color: ${colors.almostBlack};
      margin: 40px 0 0 0;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        margin: 24px 0 0 0;
      }
    }
    .phoneNumberInput {
        font-size: 20px!Important;
    }
    .requiredCh {
    margin-top: 8px;
    color: ${colors.red};
    font-size: 14px;
    margin-left: -5px;
  }

    .subtitleC {
        margin: 0;
    }
    .iUnderstand {
        display: flex;
        flex-direction: row;
        gap: 8px;
        margin-top: 32px;
        align-items: center;
        @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
            align-items: flex-start;
      }
    }

    .submitRButton {
        margin-top: 44px;
        display: flex;
        flex: 1;
        width: 100%;
        justify-content: flex-end;
    }
    .mailTo {
        font-weight: bold;
        color: ${colors.almostBlack};
        text-decoration: none;
    }
    .mailToBut {
        color: ${colors.almostBlack};
        text-decoration: none;

    }
    .secondarySubtitle {
      width: 100%;
      font-size: 20px;
      text-align: left;
      font-weight: 600;
      color: ${colors.almostBlack};
      margin: 32px 0 0 0;
      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        font-size:18px;
      }
    }

    p {
      width: 100%;
      font-size: 16px;
      text-align: left;
      font-weight: 400;
      color: ${colors.almostBlack};
      margin: 16px 0 0 0;
      line-height: 24px;
    }

    p.ending {
      width: 100%;
      font-size: 16px;
      text-align: left;
      font-weight: 400;
      color: ${colors.almostBlack};
      margin: 48px 0 0 0;
    }

    ul {
      margin: 0;
      padding-inline-start: 48px;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        padding-inline-start: 20px;
      }

      li {
        width: 100%;
        font-size: 16px;
        text-align: left;
        font-weight: 400;
        color: ${colors.almostBlack};
        list-style-type: circle;
        margin: 16px 0 0 0;
        padding-right: 16px;

        .highLight {
          font-weight: bold;
        }
      }
    }
  }

  /* @media only screen and (min-width: 767px) and (max-width: 1200px) {

    .title {
      font-size: 30px;
    }

    .subtitle {
      font-size: 18px;
    }
  }

  @media only screen and (max-width: 767px) {

    .title {
      font-size: 24px;
    }

    .subtitle {
      font-size: 16px;
    }

    .description {
      font-size: 14px;
    }
  } */
`;